"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.dropColumn('refresh_token');
    });
    await knex.schema.createTable(_globals.MetaTable.USER_REFRESH_TOKENS, (table)=>{
        table.string('fk_user_id', 20).index();
        table.string('token', 255).index();
        table.text('meta');
        table.timestamp('expires_at').index();
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.USER_REFRESH_TOKENS);
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.string('refresh_token', 255);
    });
};
